import React from 'react'


const Appmanagment = () => {
  return (
    <div>Appmanagment</div>
  )
}

export default Appmanagment